// @flow
import * as React from 'react';

import { FORM_ERROR } from 'final-form';
import { useFormState } from 'react-final-form';

import { useTranslator } from '@gandi/translate';
import { Alert, UnorderedList, TypoListItem as ListItem } from '@gandi/ui';

import { useModifiedSinceLastSubmit } from '../hooks/useModifiedSinceLastSubmit';
import type { FormErrors, FormValues } from '../types';

export function FormError(): null | React.MixedElement {
  const { submitErrors } = useFormState<FormValues>({
    subscription: { submitErrors: true },
  });
  const modifiedSinceLastSubmit = useModifiedSinceLastSubmit();
  const { __ } = useTranslator();

  const errors: FormErrors<FormValues>['FINAL_FORM/form-error'] =
    submitErrors?.[FORM_ERROR];

  if (!errors || modifiedSinceLastSubmit) {
    return null;
  }

  const message =
    errors.length === 1 ? (
      errors[0].description
    ) : (
      <UnorderedList gap="xxsmall">
        {errors.map(error => (
          // `name` (fieldname) can be multiple, prefer using description even if long, it's fine
          <ListItem key={error.description}>{error.description}</ListItem>
        ))}
      </UnorderedList>
    );

  return (
    <Alert
      title={__('Unable to validate the certificate')}
      message={message}
      intent="danger"
    />
  );
}
